import { Box, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import { SelectChildren } from "components/selection-components/select-children";
import { SelectDate } from "components/selection-components/select-date/select-date";
import { SelectGuests } from "components/selection-components/select-guests";
import SelectGuestsSkeleton from "components/selection-components/select-guests-skeleton";
import "global.less";
import { useBookingActionsContext, useBookingStateContext } from "hooks/use-booking-state";

export default function BookingWizard() {
    const externalBookingSettings = useExternalBookingSettings();
    const { guests, guestsChildren, date } = useBookingStateContext();
    const { setDate } = useBookingActionsContext();

    if (externalBookingSettings.isLoading) return <SelectGuestsSkeleton />;
    if (!externalBookingSettings.data) return <SelectGuestsSkeleton />;

    const { activateWebChildren, maxWebGuests } = externalBookingSettings.data.unitsMetaData;
    return (
        <Box
            px={ThemeSpaceVariable.Medium}
            // @ts-expect-error // ! TODO: Add an extra media query variable for really small mobile screens
            sx={{
                "@media (max-width: 320px)": {
                    px: ThemeSpaceVariable.Small,
                },
            }}
        >
            {!guests || guests > maxWebGuests ? (
                <SelectGuests />
            ) : activateWebChildren && guestsChildren === null ? (
                <SelectChildren />
            ) : !date ? (
                <SelectDate onChange={(date) => date && setDate?.(date)} date={date} />
            ) : null}
        </Box>
    );
}
